import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { YouTubePlayer } from './youtube-player/youtube-player';
import { PlaceholderImageQuality } from './youtube-player/youtube-player-placeholder';

type YouTubeResource = `video:${string}` | `playlist:${string}`;

@Component({
  selector: 'app-youtube-section',
  imports: [YouTubePlayer],
  templateUrl: './youtube-section.component.html',
  styleUrl: './youtube-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class YoutubeSectionComponent {
  resource = input.required<YouTubeResource>();
  playlistPlaceholderVideoId = input<string>();
  resourceType = computed(() => this.resource().split(':')[0]);
  resourceId = computed(() => this.resource().split(':')[1]);
  placeholderImageQuality = input<PlaceholderImageQuality>('high');
  placeholderWebpImage = input(true, { transform: booleanAttribute });
  placeholderPriority = input(false, { transform: booleanAttribute });
  playerVars = input<YT.PlayerVars | undefined>(undefined);
  _playerVars = computed(() => {
    return {
      autoplay: 0,
      ...(this.playerVars() ?? {}),
    };
  });
}
